import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/lib/isMobilePhone';

import {
  getFormattedSouthKoreaPhoneNumber,
  removeNotNumberFromString,
} from '@app/libs/inputFormat';

/**
 * 참조자는 이메일과 전화번호를 모두 입력할 수 있습니다.
 * 이메일이 아니면 숫자 외 다른 문자를 제거 후 휴대폰 전화번호인지 확인합니다.
 * 전화번호가 셀서식 문제로 1012341234 형식으로 입력되면 제일 앞에 '0' 문자를 추가합니다.
 * 휴대폰 번호인 경우 ###-####-####의 형식으로 모두 변경합니다.
 * @param contacts
 */
export default function getPhoneNumberFormattedCarbonCopyContacts(
  contacts: Array<string>
): Array<string> {
  return contacts.map((contact) => {
    if (!isEmail(contact)) {
      const value = removeNotNumberFromString(contact.trim());
      if (isMobilePhone(value, 'ko-KR')) {
        return getFormattedSouthKoreaPhoneNumber(value.startsWith('1') ? `0${value}` : value);
      }
    }

    return contact;
  });
}
